import React from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';

const TIPOS_PAGAMENTO = [
  { value: 'pix', label: 'PIX' },
  { value: 'conta', label: 'Conta Bancária' }
];

const TIPOS_PIX = [
  { value: '', label: '(selecione)' },
  { value: 'cpf', label: 'CPF' },
  { value: 'email', label: 'Email' },
  { value: 'telefone', label: 'Telefone' },
  { value: 'aleatoria', label: 'Chave Aleatória' }
];

export default function BancarioUniformesTab({ form, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Dados Bancários">
        <Select label="Forma de Pagamento" options={TIPOS_PAGAMENTO} value={form.tipo_pagamento || 'pix'} onChange={e => onChange('tipo_pagamento', e.target.value)} style={{ maxWidth: 260, marginBottom: 8 }} />
        {form.tipo_pagamento === 'conta' ? (
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 6 }}>
            <Input label="Banco" value={form.banco || ''} onChange={e => onChange('banco', e.target.value)} />
            <Input label="Agência" value={form.agencia || ''} onChange={e => onChange('agencia', e.target.value)} />
            <Input label="Conta" value={form.conta || ''} onChange={e => onChange('conta', e.target.value)} />
            <Input label="Dígito" value={form.digito || ''} onChange={e => onChange('digito', e.target.value)} />
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 6 }}>
            <Select label="Tipo de Chave" options={TIPOS_PIX} value={form.tipo_pix || ''} onChange={e => onChange('tipo_pix', e.target.value)} />
            <Input label="Chave PIX" value={form.chave_pix || ''} onChange={e => onChange('chave_pix', e.target.value)} />
          </div>
        )}
      </Secao>

      <Secao titulo="Tamanhos de Uniforme">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
          <Input label="Camisa" value={form.tam_camisa || ''} onChange={e => onChange('tam_camisa', e.target.value)} />
          <Input label="Calça" value={form.tam_calca || ''} onChange={e => onChange('tam_calca', e.target.value)} />
          <Input label="Sapato" value={form.tam_sapato || ''} onChange={e => onChange('tam_sapato', e.target.value)} />
        </div>
      </Secao>
    </div>
  );
}
